export function setCookie (name, value, expire) {
  const expires = new Date()
  expires.setTime(expires.getTime() + expire)
  document.cookie = name + '=' + value + ';expires=' + expires.toUTCString()
}
export function getCookie (name) {
  var keyValue = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return keyValue ? keyValue[2] : keyValue
}
export function getArgumentsAsObject () {
  const data = {}
  for (let index = 0; index < arguments.length; index++) {
    const argument = arguments[index]
    data[argument[0]] = argument[1]
  }
  return data
}

export const iPhoneVersion = () => {
  var iHeight = window.screen.height
  var iWidth = window.screen.width

  if (iWidth === 414 && iHeight === 896) {
    return 'iPhone-Xmax-Xr'
  } else if (iWidth === 375 && iHeight === 812) {
    return 'iPhone-X-Xs'
  } else if (iWidth === 320 && iHeight === 480) {
    return 'iPhone-4'
  } else if (iWidth === 375 && iHeight === 667) {
    return 'iPhone-6'
  } else if (iWidth === 414 && iHeight === 736) {
    return 'iPhone-6+'
  } else if (iWidth === 320 && iHeight === 568) {
    return 'iPhone-5'
  } else if (iHeight <= 480) {
    return 'iPhone-2-3'
  }
  return 'iPhone-12'
}

export const isIphone = () => {
  return !!navigator.userAgent.match(/iPhone/i)
}
